import { render } from "./deliveryEdit.vue?vue&type=template&id=15df3ba7&scoped=true"
import script from "./deliveryEdit.vue?vue&type=script&lang=js"
export * from "./deliveryEdit.vue?vue&type=script&lang=js"

import "./deliveryEdit.vue?vue&type=style&index=0&id=15df3ba7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15df3ba7"]])

export default __exports__